import { useEffect } from "react";
import React  from "react";

import {v4 as uuidv4 } from "uuid";

export default function Form({input,setInput,todes,setTodes ,editTodo,setEditTodo}){

    const updateTodo=(title,id,completed)=>{
        const newTodo = todes.map((todo) =>
            todo.id === id ? {title,id,completed} : todo
       )

        setTodes(newTodo)
        setEditTodo("")
    }

    useEffect(()=>{
        if(editTodo){
            setInput(editTodo.title)
        }else{
            setInput("")
        }
    },[setInput,editTodo])
    function onChangInput(event) {

        setInput(event.target.value)

    };

    const onSubmitForm = (event) =>{

        event.preventDefault();

        if(!editTodo){
            setTodes([...todes,{id:uuidv4(),title: input, completed : false}])
            setInput("")
        }else{

            updateTodo(input,editTodo.id,editTodo.completed)
        }

      

    }
    return(
        <form className="flex justify-center mt-14 flex-row-reverse" onSubmit={onSubmitForm}>
            <input  placeholder="ادخل مهامك..." type="text" className="w-[15rem] p-4 h-[2.4rem] bg-inherit text-white outline-none rounded-md  border-solid border-2 border-indigo-600" value={input} required
            onChange={ onChangInput}/>
            <button className="btn btn-outline btn-primary ml-4">{editTodo ? "تم" : "اضف"}</button>
        </form>
    )
}